import {
  INICIALITZAR,
  INDRET_INICIALITZAR,
  INDRET_INTRODUCCIO_MODIFICAR_CAMP,
  INDRET_INTRODUCCIO_DESCARTAR_CANVIS,
  OBTENIR_DADES_INDRET,
  ESBORRAR_INDRET_SELECCIONAT
} from "../../../actions/actionTypes";

export const INDRET_FORMULARI_DADES_EDITADES_ESTAT_INICIAL = {
  id: null,
  nom: null,
  paisatge: null,
  clima: null,
  distanciaMar: null,
  relleu: null,
  orientacio: null,
  descripcio: null,
  motiuBaixa: null,
  dataBaixa: null,
  canvis: null,
  idObservador: null,
  nomObservador: null,
  fotos: null
};

const editades = (
  state = INDRET_FORMULARI_DADES_EDITADES_ESTAT_INICIAL,
  action
) => {
  switch (action.type) {
    case INDRET_INICIALITZAR || INICIALITZAR:
    case INDRET_INTRODUCCIO_DESCARTAR_CANVIS:
    case `${OBTENIR_DADES_INDRET}_EN_CURS`:
    case `${OBTENIR_DADES_INDRET}_ERROR`:
    case ESBORRAR_INDRET_SELECCIONAT:
      return INDRET_FORMULARI_DADES_EDITADES_ESTAT_INICIAL;

    case INDRET_INTRODUCCIO_MODIFICAR_CAMP: {
      const { idCamp, valor } = action;
      return { ...state, [idCamp]: valor };
    }

    case `${OBTENIR_DADES_INDRET}_SUCCESS`: {
      return action.payload.indret[0];
    }

    default:
      return state;
  }
};

export default editades;
